<div class="confirm-dialog-container">
    <div class="dialog-header">
        <h3 class="dialog-title">{{ data.title }}</h3>
    </div>

    <div class="dialog-body">
        <p class="dialog-message" [innerHTML]="sanitizedMessage"></p>
    </div>

    <div class="dialog-actions">
        <button class="btn cancel-modal-btn" (click)="onCancel()">{{ data.secondaryButtonText }}</button>
        <button class="btn save-modal-btn" (click)="primaryClick()" [class.button-spinner]="isLoading"
            [disabled]="isLoading">{{ data.primaryButtonText }}</button>
    </div>
</div>